<template>
    <div>
        <buttonlist @help="help"
                ref="SetBtn"></buttonlist>
        <div style="margin-top: 5px">
            <tr>
                <td>{{$t('getapi[4209]')}}</td>
                <td>
                    <routejump :urlNo="41">
                    <el-input
                            v-model="schedule_no"
                            type="text"
                            readonly
                            size="mini"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectPlanNo"></i>
                    </el-input>
                    </routejump>
                </td>
                <!--<el-button @click="test" size="mini" type="primary">输出值 </el-button>-->
                <el-button @click="toHistory" size="mini" type="primary" style="margin-left: 5px" :disabled="!btn.soreporthistory">{{$t('getapi[6681]')}}</el-button>
                <el-button @click="toInvIn" size="mini" type="primary" :disabled="!btn.relatedinvin">{{$t('getapi[7104]')}}</el-button>
               <!-- <el-button @click="toIpOrder" size="mini" type="primary" :disabled="!btn.relatediporder">相关外协订单 </el-button>-->
                <el-button @click="toIssue" size="mini" type="primary" :disabled="!btn.relatedissue">{{$t('getapi[7105]')}}</el-button>
                <el-button @click="toReportSO" size="mini" type="primary" :disabled="!btn.reportso">{{$t('getapi[6901]')}}</el-button>
            </tr>
        </div>

        <el-table
                id="xpane-0"
                :data="dataSet"
                ref="singleTable"
                v-loading="loading"
                :highlight-current-row="true"
                border
                size="mini"
                :height="tableHeight"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
                header-row-class-name="headerclass"
                row-key="uniquenumber"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                lazy
                :load="load"
                style="width: 100%; margin-top:5px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="uniquenumber" label="" width="100">
                <template>
                    <i class="el-icon-tickets"></i>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="parttype" :label="$t('getapi[6117]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sostatus" :label="$t('getapi[6356]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[1479]')"></el-table-column>
            <el-table-column prop="bomstdqty" :label="$t('getapi[4269]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.bomstdqty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="plan_finish_qty" :label="$t('getapi[6357]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.plan_finish_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="stockqty" :label="$t('getapi[6360]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.stockqty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="total_issue_qty" :label="$t('getapi[2874]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.total_issue_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="to_inv_qty" :label="$t('getapi[4219]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.to_inv_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="scrap_qty" :label="$t('getapi[4220]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.scrap_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="finished_product_receive" :label="$t('getapi[6358]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.finished_product_receive | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="actual_finish_qty" :label="$t('getapi[6359]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.actual_finish_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[888]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="datestr" :label="$t('getapi[4215]')"></el-table-column>
        </el-table>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SO/GetPlanNoPopupDataList'"
                  @callback="getPlanNo" ref="planno"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '2_solevel',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                loading: '',
                DbTbNames: '', //表名
                dataSet: [],
                schedule_no: '', // 计划单号
                selectData: [],
                btn: {
                    soreporthistory: false,
                    relatedinvin: false,
                    relatediporder: false,
                    relatedissue: false,
                    reportso: false,
                },
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            this.btnauthority();
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initAllForm()
                })
            },
        },
        mounted() {
            let that = this
            this.authority();
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4004]"),this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('refresh');
            },
            btnauthority() {
                let that = this;
                that.btn.soreporthistory = false
                that.btn.relatedinvin= false
                that.btn.relatediporder= false
                that.btn.relatedissue= false
                that.btn.reportso= false
                if(that.selectData.length == 1){
                    if(that.selectData[0].so_code != "" && that.selectData[0].so_code != "虚拟件" && that.selectData[0].so_code != "采购件" && that.selectData[0].so_code != "自制件，未下SO单"){
                        if (that.$limits.authority('plv2', 208, 1) >0) {
                            that.btn.soreporthistory = true
                        }
                        if (that.$limits.authority('plv2', 187, 1) >0) {
                            that.btn.relatedinvin = true
                        }
                        if (that.$limits.authority('plv2', 130, 1) >0) {
                            that.btn.relatediporder = true
                            that.btn.relatedissue = true
                        }
                        if (that.selectData[0].so_status != null && (that.selectData[0].so_status == "1" || that.selectData[0].so_status == "2"))
                        {
                            if (that.$limits.authority('plv4', 315, 1) == 1)//可用
                            {
                                that.btn.reportso= true
                            }
                        }
                    }
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            tableRowClassName({row, rowIndex}) {
                if(row.color == 1){
                    return 'blue'
                }
                if(row.color == 2){
                    return 'red'
                }
                if(row.color == 3){
                    return 'gray'
                }
                if(row.color == 4){
                    return 'black'
                }
                if(row.bgcolor == 1){
                    return 'aliceblue'
                }
            },
            //选择客户编码
            selectPlanNo() {
                let that = this;
                that.$refs.planno.clearInput(true);
            },
            getPlanNo(val) {
                let that = this;
                that.schedule_no = val.schedule_no
                that.getView()
            },
            getView() {
                let that = this
                let parm = {
                    schedule_no: that.schedule_no
                }
                that.loading = true;
                that.$http.urlpost('/Pro/SO/GetDatatRootSOInfosForPlanNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.List;
                        for(let i =0;i<that.dataSet.length;i++){
                            that.dataSet[i].hasChildren = true
                            /*that.getSonView(that.dataSet[i])*/
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 获取子数据
            getSonView(row){
                let that = this
                if(row.hasChildren == false){
                    return
                }
                let parm = {
                    schedule_no: that.schedule_no,
                    parttype: row.parttype,
                    socode: row.so_code,
                    plan_finish_qty: row.plan_finish_qty,
                    part_code: row.part_code,
                    part_version: row.part_version,
                    expand: row.expand
                }
                that.token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + '/Pro/SO/GetDatatRootSOInfosForPlanNoSocode?token=' + that.token,
                    type: 'post',
                    async: false,
                    data: JSON.stringify(parm),
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent.List
                            if(data.length != 0){
                                for(let i = 0;i<data.length;i++){
                                    data[i].hasChildren = true
                                }
                                row.children = data
                            } else {
                                row.hasChildren = true
                                row.children = []
                            }
                        } else {
                            //Message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
                /*let parm = {
                    schedule_no: that.schedule_no,
                    parttype: row.parttype,
                    socode: row.so_code,
                    plan_finish_qty: row.plan_finish_qty,
                    part_code: row.part_code,
                    part_version: row.part_version,
                    expand: row.expand
                }
                that.$http.urlpost('/Pro/SO/GetDatatRootSOInfosForPlanNoSocode', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.List
                        if(data.length != 0){
                            row.children = data
                            for(let i = 0;i<data.length;i++){
                                data[i].hasChildren = true
                                /!*that.getSonView(data[i])*!/
                            }
                        } else {
                            row.hasChildren = false
                        }
                    }
                });*/
            },
            load(row, treeNode, resolve) {
                let that = this
                that.getSonView(row)
                console.log('执行' + JSON.stringify(row))
                setTimeout(() => {
                    resolve(
                        row.children
                    )
                }, 1000)
            },
            test(){
                let that = this
                console.log(that.dataSet)
            },
            toHistory(){
                let that = this
                that.$store.commit('setSharedParams',{
                    order_no: that.selectData[0].so_code
                });
                let item = {
                    label: '汇报历史一览',
                    name: '2_reporthistoryview',
                    path: '/reporthistoryview',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/reporthistoryview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            toInvIn(){
                let that = this
                that.$store.commit('setSharedParams',{
                    order_no: that.selectData[0].so_code
                });
                let item = {
                    label:this.$t("getapi[4019]"),
                    name: '2_invinlist',
                    path: '/invinlist',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/invinlist'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            toIpOrder(){

            },
            toIssue(){
                let that = this
                that.$store.commit('setSharedParams',{
                    order_no: that.selectData[0].so_code
                });
                let item = {
                    label:this.$t("getapi[4011]"),
                    name: '2_soissuematerialsdatalist',
                    path: '/soissuematerialsdatalist',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/soissuematerialsdatalist'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            toReportSO(){
                let that = this;
                /*that.visMPSInfo = true;*/
                that.$store.commit('setSharedParams',{
                    Code: that.selectData[0].so_code
                });
                let item = {
                    label: '直接汇报',
                    name: 'reportdirectly',
                    path: '/reportdirectly',
                    url: '/reportdirectly',
                    icon: 'video-play'
                };
                this.$router.push({path: '/reportdirectly'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            }
        }
    };
</script>

<style  scoped lang="less">
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
    /deep/.blue{
        color: blue;
    }
    /deep/.red{
        color: red;
    }
    /deep/.gray{
        color: #805043;
    }
    /deep/.black{
        color: black
    }
    /deep/.aliceblue{
        background: #c0fff3;
    }
</style>
<style>
    .el-message-box {
        width: 600px;
    }

</style>
